import { api } from './api'

export interface LoginResponse {
  token: string
  user?: {
    id: string
    email: string
    name: string
    avatar_url?: string | null
  }
  tenant?: {
    id: string
    name?: string
    slug?: string
    role?: string
  }
  tenant_selection_required?: boolean
  needs_payment?: boolean
  trial_ends_at?: string | null
  billing_status?: string
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post<{ data: LoginResponse }>('/api/v1/auth/login', {
      email,
      password,
    })
    return response.data.data
  },
}
